/**
 * Which visitor locations get OPT_IN (deny by default + banner) and which get OPT_OUT (trackers
 * load, no banner, Cookie settings link lets the visitor opt out). Everything not listed here is
 * OPT_OUT, and an unknown location is denied (see jurisdiction.ts).
 *
 * Source and rationale: /Users/yonatannaor/projects/Blueticks/.crew/report-259-WS08.md,
 * section "## Consent by jurisdiction (WS08 #282)". That report's citations are mostly secondary
 * sources; counsel must verify the primary texts before relying on this list.
 *
 * To move a jurisdiction (e.g. Canada outside Quebec, flagged in the report as the first candidate
 * for OPT_OUT on counsel review), change this file only. Website-only: not part of the shared
 * contract.ts, so the web app copy does not need it.
 */

/** ISO 3166-1 alpha-2 codes: EU 27, EEA (IS, LI, NO), GB, CH, IL, BR, TR. */
export const OPT_IN_COUNTRIES: ReadonlySet<string> = new Set([
  // EU 27
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT',
  'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  // EEA non-EU
  'IS', 'LI', 'NO',
  // United Kingdom, Switzerland, Israel, Brazil, Turkey
  'GB', 'CH', 'IL', 'BR', 'TR',
]);

/**
 * ISO 3166-2 subdivision codes (without the country prefix) that are OPT_IN inside a country that is
 * otherwise OPT_OUT. Quebec only: Canada outside Quebec is OPT_OUT.
 */
export const OPT_IN_REGIONS: Readonly<Record<string, ReadonlySet<string>>> = {
  CA: new Set(['QC']),
};

export function isOptInLocation(country: string, region: string | null): boolean {
  if (OPT_IN_COUNTRIES.has(country)) return true;
  return region !== null && OPT_IN_REGIONS[country]?.has(region) === true;
}
